<script>
  import BinderCard from './BinderCard.svelte';

  /** @type {{ binders: Array<{ url: string, name: string, owner?: string, hasTrade?: boolean, tradeId?: string, isStarred?: boolean, binderUrl?: string, wantCount?: number }>, onStar?: (binder: any) => void, onRemove?: (binder: any) => void, onCancelTrade?: (binder: any) => void }} */
  let { binders = [], onStar, onRemove, onCancelTrade } = $props();
</script>

{#if binders.length > 0}
  <div class="recent-binders">
    <div class="divider"></div>
    <h2>Recent Binders</h2>
    <ul class="binder-list">
      {#each binders as binder, i (binder.url)}
        <BinderCard {binder} index={i} {onStar} {onRemove} {onCancelTrade} />
      {/each}
    </ul>
  </div>
{/if}

<style>
  .recent-binders {
    max-width: 700px;
    margin: 0 auto 2rem;
    padding: 0 1rem;
  }

  .divider {
    max-width: 200px;
    margin: 0 auto 2.5rem;
    height: 1px;
    background: linear-gradient(to right, transparent, #d1d5db, transparent);
  }

  h2 {
    font-size: 1.25rem;
    font-weight: 600;
    color: #374151;
    margin-bottom: 1.5rem;
    text-align: center;
    letter-spacing: -0.01em;
  }

  .binder-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    gap: 1.5rem;
  }
</style>
